function getScrollOffsets (_w) {
  _w = _w || window;
  if (_w.pageXOffset != null) {
    return {
      x: _w.pageXOffset,
      y: _w.pageYOffset,
    };
  }
  var _d = _w.document;
  return {
    x: _d.body.scrollLeft,
    y: _d.body.scrpllTop,
  };
}

function getViewPortSize (_w) {
  _w = _w || window;
  if (_w.innerWidth != null) {
    return {
      x: _w.innerWidth,
      y: _w.innerHeight,
    };
  }
  var _d = _w.document;
  return {
    x: _d.body.clientWidth,
    y: _d.body.clientHeight,
  };
}

export const scrollPosition = (_obj) => {
  var targetX, targetY;
  if (!_obj) {
    targetX = 0;
    targetY = 70;
  } else {
    if (typeof (_obj) === 'string') {
      _obj = document.getElementById(_obj);
    }
    targetX = _obj.getBoundingClientRect().left + getScrollOffsets().x;
    targetY = _obj.getBoundingClientRect().top + getScrollOffsets().y;
  }

  targetY -= 70;

  var maxTargetX = document.body.scrollWidth - getViewPortSize().x;
  if (targetX >= maxTargetX) targetX = maxTargetX;
  if (targetX < 0) targetX = 0;
  var maxTargetY = document.body.scrollHeight - getViewPortSize().y;
  if (targetY >= maxTargetY) targetY = maxTargetY;
  if (targetY < 0) targetY = 0;

  clearInterval(window.tempTimer);

  window.tempTimer = setInterval(function () {
    var currentY = getScrollOffsets().y;
    var currentX = getScrollOffsets().x;
    var tempTargetY = currentY - (currentY - targetY) / 13;
    var tempTargetX = currentX - (currentX - targetX) / 13;
    if (Math.abs(tempTargetY - currentY) < 1) {
      tempTargetY - currentY > 0 ? tempTargetY++ : tempTargetY--;
    }
    if (Math.abs(tempTargetX - currentX) < 1) {
      tempTargetX - currentX > 0 ? tempTargetX++ : tempTargetX--;
    }
    window.scrollTo(tempTargetX, tempTargetY);
    if (Math.abs(getScrollOffsets().y - targetY) <= 1 && Math.abs(getScrollOffsets().x - targetX) <= 1) {
      clearInterval(window.tempTimer);
      window.scrollTo(targetX, targetY);
    }
  }, 10);
};



// WEBPACK FOOTER //
// ./src/utils/scroll.js